// extracted by mini-css-extract-plugin
export default {"year":"statistic_year__UkvzZ","scrollableContainerStyle":"statistic_scrollableContainerStyle__YI5SX"};